export default "__VITE_ASSET__DHftgUu$__"